<template>
  <div>
    <content-placeholder v-if="loading">
      <el-card>
        <p class="text text-10 text-h-20"></p>
        <p class="text text-50"></p>
        <p class="text text-25"></p>
        <p class="text text-25"></p>
      </el-card>
    </content-placeholder>

    <el-card v-else v-loading="reloading">
      <div slot="header">Comments</div>
      <div slot="actions">Total: {{comments.length}}</div>

      <div v-if="loadError">
        <error-block :buttonCallback="fetchCommentsForCommentable" />
      </div>

      <div v-else>
        <div class="comment-shell" ref="shell" v-if="comments && comments.length > 0" :style="{maxHeight:maxHeight+'px'}">
          <comment-item v-for="(comment, index) in comments" :comment="comment" :key="index" />
        </div>
        <div v-else class="not-found">
          <el-alert type="info" align="center" title="" :closable="false" center><b>No comments yet.</b><br>Be the first to say something!</el-alert>
        </div>
      </div>

      <div slot="footer">
        <comment-form :id="id" :type="type" :scrollToBottom="scrollToBottom" />
      </div>
    </el-card>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import CommentItem from '@/components/comment/CommentItem';
  import CommentForm from '@/components/comment/CommentForm';

  export default {
    name: 'CommentsList',
    props: {
      maxHeight: {
        type: Number,
        required: false,
      },
      id: {
        type: Number,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
    },
    components: {
      commentItem: CommentItem,
      commentForm: CommentForm,
    },
    created() {
      this.fetchCommentsForCommentable();
    },
    data() {
      return {
        loading: true,
        reloading: false,
        loadError: null,
      };
    },
    computed: {
      ...mapGetters('entities/comments', ['query']),

      comments() {
        return this.query()
          .with('author')
          .where('commentable_id', this.id)
          .where('commentable_type', this.type)
          .orderBy('created_at', 'asc')
          .get();
      },
    },
    methods: {
      ...mapActions('entities/comments', ['fetchComments']),

      scrollToBottom() {
        const shell = this.$refs.shell;
        if (shell) {
          shell.scrollTop = shell.scrollHeight;
        }
      },

      fetchCommentsForCommentable() {
        this.showLoader();
        this.loadError = null;
        this.fetchComments({ commentable_id: this.id, commentable_type: this.type })
          .then((response) => {
            if (!response.status) {
              this.loadError = response.error;
            }
            this.hideLoader();
          }).then(() => {
            setTimeout(() => {
              if (this.comments.length > 0) {
                this.scrollToBottom();
              }
            }, 1000);
          });
      },

      showLoader() {
        if (this.comments.length) {
          this.reloading = true;
        } else {
          this.loading = true;
        }
      },

      hideLoader() {
        this.reloading = false;
        this.loading = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
.comment-shell{
  overflow: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/comment/CommentsList.vue